import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './app';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import defaultTheme from './theme';
import { ThemeProvider } from 'styled-components';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store';
const ThemeProviderAny = ThemeProvider as unknown as React.ComponentType<any>;

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <GoogleOAuthProvider clientId="481440991538-v64lnamg5ats650dlb9rckk2jsr0887t.apps.googleusercontent.com">
            <ThemeProviderAny theme={defaultTheme}>
              <App />
            </ThemeProviderAny>
          </GoogleOAuthProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


